/* Krautz Ironz – ki-search.js (global geladen, layout/theme.liquid)
 * Live-Suche für jedes Formular mit [data-ki-ps] (Header-Suche Desktop, mobile Suchleiste):
 *  - Shopify Predictive Search (/search/suggest) mit Produkten (Bild, Marke, Preis), Suchvorschlägen, Kategorien
 *    und Ratgeber-Artikeln, gerendert über sections/ki-predictive-search.liquid (Section Rendering API)
 *  - durchsucht auch Artikelnummern (SKU), Marke, Produkttyp und Tags
 *  - Synonyme: Gruppen aus der Section „KI – Header“ (eine Gruppe pro Zeile, kommagetrennt). Enthält die Eingabe einen
 *    Begriff einer Gruppe, wird zusätzlich mit dem ersten Begriff der Gruppe gesucht und die Produkte zusammengeführt.
 *  - Texte aus den Header-Einstellungen (#KiSearchConfig) → übersetzbar mit Translate & Adapt
 *  - Tastatur: Pfeil runter/hoch, Esc; Klick außerhalb schließt
 * Sicherheit: Antworten werden per DOMParser geparst und als Knoten importiert, keine Rohtexte in innerHTML.
 */
(function () {
  'use strict';
  if (window.KISearch) return;

  var DEF = {
    search_for: 'Nach „{q}“ suchen',
    products: 'Produkte',
    collections: 'Kategorien',
    articles: 'Ratgeber',
    empty: 'Keine Direkttreffer – Enter drücken für die vollständige Suche.',
    sold_out: 'Ausverkauft',
    from: 'ab',
    results: 'Suchvorschläge'
  };
  var CFG = { enabled: true, strings: {}, synonyms: [] };
  var MAX_PRODUCTS = 8;

  function parseSynonyms(txt) {
    return String(txt || '').split(/\r?\n/).map(function (line) {
      return line.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    }).filter(function (g) { return g.length > 1; });
  }
  function readConfig() {
    var el = document.getElementById('KiSearchConfig');
    if (!el) return;
    try {
      var c = JSON.parse(el.textContent);
      CFG.enabled = c.enabled !== false;
      CFG.strings = c.strings || {};
      CFG.synonyms = parseSynonyms(c.synonyms);
    } catch (e) {}
  }
  function S(k) { return CFG.strings[k] || DEF[k] || ''; }
  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  /* Alternativ-Suchbegriffe aus den Synonym-Gruppen (max. 2): ganzes Wort oder angefangenes letztes Wort (ab 4 Zeichen) */
  function alternatives(q) {
    var ql = q.toLowerCase().replace(/\s+/g, ' ').trim();
    var words = ql.split(' ');
    var last = words[words.length - 1];
    var out = [];
    CFG.synonyms.forEach(function (g) {
      if (out.length >= 2) return;
      for (var i = 0; i < g.length; i++) {
        var term = g[i];
        var target = term === g[0] ? g[1] : g[0];
        var re = new RegExp('(^|\\s)' + esc(term) + '(?=\\s|$)');
        var nq = null;
        if (re.test(ql)) { nq = ql.replace(re, '$1' + target); out.exact = true; }
        else if (last.length >= 4 && term.indexOf(last) === 0 && term.indexOf(' ') < 0) nq = words.slice(0, -1).concat(target).join(' ');
        if (nq && nq !== ql && out.indexOf(nq) < 0) { out.push(nq); return; }
      }
    });
    return out;
  }

  function buildUrl(base, q) {
    return base + '?q=' + encodeURIComponent(q) +
      '&section_id=ki-predictive-search' +
      '&resources[type]=product,query,collection,article' +
      '&resources[limit]=6' +
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
  }

  function applyStrings(node) {
    Array.prototype.forEach.call(node.querySelectorAll('[data-t]'), function (el) {
      var k = el.getAttribute('data-t');
      if (k === 'search_for') {
        var q = el.getAttribute('data-q') || '';
        var parts = S('search_for').split('{q}');
        el.textContent = '';
        el.appendChild(document.createTextNode(parts[0] || ''));
        if (parts.length > 1) {
          var b = document.createElement('b');
          b.textContent = q;
          el.appendChild(b);
          el.appendChild(document.createTextNode(parts.slice(1).join(q)));
        }
      } else if (S(k)) {
        el.textContent = S(k);
      }
    });
    var ul = node.querySelector('.psr-list');
    if (ul) ul.setAttribute('aria-label', S('results'));
  }

  /* Produkte aus den Synonym-Antworten einfügen (ohne Doppelte). front=true: exakter Synonym-Treffer -> Synonym-Produkte zuerst */
  function mergeProducts(node, extraDocs, front) {
    var list = node.querySelector('.psr-list');
    if (!list) return;
    var have = {}, count = 0, own = Array.prototype.slice.call(list.querySelectorAll('li[data-psr-p]')), firstOwn = own[0] || null, added = 0;
    own.forEach(function (li) { have[li.getAttribute('data-psr-p')] = 1; count++; });
    if (front) count = 0;
    extraDocs.forEach(function (d) {
      if (!d) return;
      var heading = list.querySelector('.psr-g[data-t="products"]');
      Array.prototype.forEach.call(d.querySelectorAll('li[data-psr-p]'), function (li) {
        var pid = li.getAttribute('data-psr-p');
        if (have[pid] || count >= MAX_PRODUCTS) return;
        if (!heading) {
          var h = d.querySelector('.psr-g[data-t="products"]');
          if (!h) return;
          heading = document.importNode(h, true);
          list.insertBefore(heading, list.querySelector('.psr-g'));
        }
        if (front && firstOwn) { list.insertBefore(document.importNode(li, true), firstOwn); }
        else {
          var prods = list.querySelectorAll('li[data-psr-p]');
          var after = prods.length ? prods[prods.length - 1] : heading;
          list.insertBefore(document.importNode(li, true), after.nextSibling);
        }
        have[pid] = 1;
        count++; added++;
      });
    });
    if (front) { var all = list.querySelectorAll('li[data-psr-p]'); for (var k = MAX_PRODUCTS; k < all.length; k++) all[k].parentNode.removeChild(all[k]); }
    if (count || added) { var e = node.querySelector('.psr-empty'); if (e) e.parentNode.removeChild(e); }
  }

  function init(form) {
    if (form.__kiPs) return;
    var input = form.querySelector('input[type="search"], input[name="q"]');
    if (!input || !window.fetch || !window.DOMParser) return;
    form.__kiPs = true;
    var base = form.getAttribute('data-ki-ps-url') || '/search/suggest';
    var kind = form.getAttribute('data-ki-ps') || 'header';
    var host = form.parentNode;
    var id = 'KiPs-' + Math.random().toString(36).slice(2, 9);
    var panel = document.createElement('div');
    panel.className = 'psr-panel';
    panel.id = id;
    panel.hidden = true;
    panel.setAttribute('data-ki-ps-panel', kind);
    host.classList.add('psr-host');
    host.insertBefore(panel, form.nextSibling);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', id);
    input.setAttribute('autocomplete', 'off');

    var timer = 0, ctrl = null, open = false, cache = {}, seq = 0;

    function close() {
      open = false;
      panel.hidden = true;
      panel.replaceChildren();
      input.setAttribute('aria-expanded', 'false');
      form.classList.remove('is-open');
    }
    function get(q, signal) {
      if (cache[q]) return cache[q];
      var p = fetch(buildUrl(base, q), { credentials: 'same-origin', signal: signal })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error(r.status)); })
        .then(function (h) { return new DOMParser().parseFromString(h, 'text/html'); });
      cache[q] = p;
      p.catch(function () { delete cache[q]; });
      return p;
    }
    function render(doc, extra, front) {
      var src = doc && doc.querySelector('[data-ki-psr]');
      if (!src) { close(); return; }
      var node = document.importNode(src, true);
      if (extra.length) mergeProducts(node, extra, front);
      applyStrings(node);
      panel.replaceChildren(node);
      if (!node.querySelector('[data-ki-psr-item]') && !node.querySelector('.psr-empty')) { close(); return; }
      panel.hidden = false;
      open = true;
      input.setAttribute('aria-expanded', 'true');
      form.classList.add('is-open');
    }
    function run() {
      if (!CFG.enabled) return;
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      var signal = ctrl ? ctrl.signal : undefined;
      var mine = ++seq;
      form.classList.add('is-loading');
      var alts = alternatives(q);
      Promise.all([get(q, signal)].concat(alts.map(function (a) { return get(a, signal).catch(function () { return null; }); })))
        .then(function (docs) { if (mine === seq) render(docs[0], docs.slice(1), !!alts.exact); })
        .catch(function () {})
        .then(function () { if (mine === seq) form.classList.remove('is-loading'); });
    }

    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 170); });
    input.addEventListener('focus', function () { if (input.value.trim().length > 1 && !open) run(); });
    form.addEventListener('submit', close);
    document.addEventListener('click', function (e) { if (open && !host.contains(e.target)) close(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { if (open) { e.preventDefault(); close(); } }
      else if (e.key === 'ArrowDown' && open) {
        var first = panel.querySelector('[data-ki-psr-item]');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });
    panel.addEventListener('keydown', function (e) {
      var items = Array.prototype.slice.call(panel.querySelectorAll('[data-ki-psr-item]'));
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) input.focus(); else items[i - 1].focus(); }
      else if (e.key === 'Escape') { e.preventDefault(); close(); input.focus(); }
    });
    panel.addEventListener('focusout', function () {
      setTimeout(function () { if (open && !host.contains(document.activeElement)) close(); }, 0);
    });
  }

  function boot(scope) {
    readConfig();
    Array.prototype.forEach.call((scope || document).querySelectorAll('form[data-ki-ps]'), init);
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  window.KISearch = { boot: boot, alternatives: alternatives };
})();
